__turbopack_context__.v({
  "tag": "CourseTag-module__cJYoDq__tag",
  "tagDot": "CourseTag-module__cJYoDq__tagDot",
  "tagText": "CourseTag-module__cJYoDq__tagText",
});
